"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../../shared-types/enums");
const newContactSchema = zod_1.z.object({
    name: zod_1.z.string().max(150),
    email: zod_1.z.string().email().nullable(),
    sms: zod_1.z
        .string()
        .regex(/^\+?[1-9]\d{1,14}$/, {
        message: 'Invalid international phone number format',
    })
        .nullable(),
    language: enums_1.languageEnum,
    groups: zod_1.z.array(zod_1.z.number()).optional(),
});
exports.requestSchema = zod_1.z
    .object({
    contactsToCreate: zod_1.z.array(newContactSchema).optional(),
    contactsToDelete: zod_1.z.array(zod_1.z.string()).optional(),
    contactsToUpdate: zod_1.z.record(zod_1.z.string(), newContactSchema).optional(),
})
    .refine((args) => !!Object.keys(args).length, {
    message: 'Request object must contain at least one argument',
});
exports.path = '/contacts-management';
//# sourceMappingURL=index.js.map